/**
 * ADMIN CONFIGURATION
 * ─────────────────────────────────────────────────────────────────────────────
 * Primary admin is identified by hardcoded email (goulas.evan@gmail.com).
 * Additional admins can be promoted via the Admin Panel — their is_admin flag
 * is stored in access_requests and mirrored to user_profiles.
 * ─────────────────────────────────────────────────────────────────────────────
 */

export const ADMIN_EMAIL = 'goulas.evan@gmail.com';

/**
 * Returns true if the supplied Supabase user object belongs to an admin.
 * Checks:
 *   1. Hardcoded primary admin email
 *   2. user_metadata.is_admin (set during sign-in enrichment in AuthContext)
 */
export function isAdminUser(user: { email?: string | null; user_metadata?: any; app_metadata?: any } | null): boolean {
  if (!user?.email) return false;
  // Primary hardcoded admin
  if (user.email.toLowerCase() === ADMIN_EMAIL.toLowerCase()) return true;
  // DB-promoted admin (set via user_metadata enrichment in AuthContext)
  if (user.user_metadata?.is_admin === true) return true;
  return false;
}
